require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-buy-now-pay-later.json") })
        }
      }, "path---es-articles-tags-buy-now-pay-later");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-buy-now-pay-later!./.cache/json/es-articles-tags-buy-now-pay-later.json
// module id = 2277
// module chunks = 231608221292675